import { Http } from "../http"
import { HttpTest } from "../http-test"
import { Routes } from "../routes"

export class BaseEndpoint {
  public routes = Routes

  constructor(public http: Http | HttpTest) {}
}
